<script lang="ts">
  import LinkComp from "$components/link.svelte";
  import NavItem from "$components/navbar/nav-item.svelte";
  export let nav: NavItem[];
  // console.log(nav, "nav");
</script>

<div class="nav-menu">
  <ul>
    {#each nav as item}
      {#if item?.separator}
        <!-- separator -->
      {:else}
        <li class="inner-li">
          <div>
            {item.label}
            <div class="inner-div">
              {#if item?.subItems}
                <ul>
                  {#each item.subItems.children || [] as singleChildren}
                    <li>
                      <LinkComp href={singleChildren?.url || "/"}>{singleChildren.label}</LinkComp>
                    </li>
                  {/each}
                </ul>
              {/if}
            </div>
          </div>
        </li>
      {/if}
    {/each}
  </ul>
</div>

<style lang="scss">
  @use "@styles/breakpoint-mixins" as *;
  .nav-menu {
    position: absolute;
    top: 0;
    width: 11em;
    background: #fff;
    margin: 0;
    padding: 0.2em;
    z-index: var(--z1);

    ul {
      margin: 0;
      padding: 0;

      li {
        width: 100%;
        position: relative;

        &.inner-li {
          display: inline-block;
          > div {
            display: block;
            padding: 1em;
            text-align: center;
            width: 100%;
            text-decoration: none;

            &:hover,
            &:focus {
              background-color: #e6e6e6;
            }

            .inner-div {
              display: none;
              position: absolute;
              top: 0;
              left: 95%;
              background-color: #fff;
              min-width: 160px;
              z-index: 1;

              ul {
                list-style-type: none;
                margin: 0;
                padding: 0;

                li {
                  text-align: left;
                  list-style-type: none;
                  padding: 8px 16px;
                  background-color: #fff;
                  &:hover {
                    background-color: #e6e6e6;
                  }
                  a {
                    text-decoration: none;
                  }
                }
              }
            }
          }

          &:hover > div .inner-div,
          &:focus > div .inner-div {
            display: block;
          }
        }
      }
    }
  }
</style>
